// extracted by mini-css-extract-plugin
export default {"ellipsis":"U_jEBQHKB4omC1abrEVI","wrapper":"TvLXhKySZtAmzDiBUz1R","spin":"kIkkRI6e5cdv70ip9sdA"};